import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { Link } from 'react-router-dom'
import { toast } from 'sonner'

import { Button } from '@/components/button'
import { ErrorField } from '@/components/error-field'
import * as Input from '@/components/input'
import { SideImageForm } from '@/components/side-image-form'
import {
  resetPasswordEmailFormValidationSchema,
  ResetPasswordEmailFormValues,
} from '@/schemas/reset-password'
import api from '@/services/api'

export function EmailResetPassword() {
  const { register, handleSubmit, formState } =
    useForm<ResetPasswordEmailFormValues>({
      resolver: zodResolver(resetPasswordEmailFormValidationSchema),
      defaultValues: {
        email: '',
      },
    })

  async function handleResetEmail({ email }: ResetPasswordEmailFormValues) {
    const formData = { email: email.toLowerCase() }
    await api
      .post('/sendmail', formData)
      .then(({ data }) => {
        const message =
          data ||
          'Email enviado com sucesso! Verifique a caixa do seu e-mail e siga as instruções.'
        toast.success(message, {
          className: 'email-reset-message-success',
        })
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          className: 'email-reset-message-error',
        })
      })
  }
  return (
    <div className="grid flex-1 grid-cols-1 bg-monochromatic-200 lg:grid-cols-9">
      <SideImageForm
        title="Torne-se um guardião ambiental"
        className="bg-resetEmailPassword"
      />
      <div className="my-auto px-10 py-10 md:px-20 lg:col-span-4 xl:px-36 2xl:px-56">
        <h1 className="mb-10 text-center text-3xl font-bold text-bios-title lg:text-start xl:text-4xl 2xl:mb-20 2xl:text-5xl">
          Redefinir senha
        </h1>
        <form onSubmit={handleSubmit(handleResetEmail)} className="space-y-6">
          <div>
            <Input.Label
              htmlFor="email"
              mandatory
              data-testid="email-reset-label-email"
            >
              E-mail
            </Input.Label>
            <Input.Root withError={!!formState.errors.email}>
              <Input.Control
                id="email"
                type="text"
                placeholder="Digite seu e-mail"
                data-testid="email-reset-input-email"
                {...register('email')}
              />
            </Input.Root>
            {formState.errors.email && (
              <ErrorField>{formState.errors.email.message}</ErrorField>
            )}
          </div>

          <Button
            className="w-full"
            type="submit"
            disabled={formState.isSubmitting}
            isSubmitting={formState.isSubmitting}
            data-testid="email-reset-button-submit"
          >
            Confirmar
          </Button>

          <div className="flex flex-col items-center justify-center gap-1 text-zinc-600 sm:flex-row">
            <p>Lembrou a senha?</p>
            <Link
              to="/login"
              className="font-bold text-bios-secondary underline hover:text-bios-primary"
              data-testid="email-reset-link-login"
            >
              Faça o login
            </Link>
          </div>
        </form>
      </div>
    </div>
  )
}
